/**
 * Shared running icon used for the player CTA and other motion-themed UI.
 */
import React from 'react';
import { cn } from '@/lib/utils';

interface RunningIconProps {
  className?: string;
  size?: number;
}

export const RunningIcon: React.FC<RunningIconProps> = ({ className, size = 16 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      width={size}
      height={size}
      className={cn('shrink-0', className)}
    >
      <path d="M20.565,11l-2.136-3.547c-.54-.896-1.525-1.453-2.57-1.453h-6.478l-2.276,4.553,1.789,.895,1.724-3.447h1.911l-1.753,4.273c-.553,1.35-.06,2.895,1.172,3.674l4.117,2.604v5.449h2v-6.551l-3.017-1.908,2.426-5.797,1.959,3.256h4.565v-2h-3.435ZM14.5,2.5c0-1.381,1.119-2.5,2.5-2.5s2.5,1.119,2.5,2.5-1.119,2.5-2.5,2.5-2.5-1.119-2.5-2.5Zm-3.62,15.138l.665,.421-.8,1.942H4v-2h5.406l.494-1.199c.289,.311,.606,.601,.98,.837Zm.12-13.638H2V2H11v2ZM5,12H0v-2H5v2Zm1.146-4H1v-2H7.146l-1,2Z" />
    </svg>
  );
};
